import type { ReactNode } from "react";

export type TabId = "home" | "official" | "review" | "history";

interface Tab {
  id: TabId;
  label: string;
  icon: ReactNode;
}

interface BottomNavProps {
  tabs: Tab[];
  activeTab: TabId;
  onTabChange: (id: TabId) => void;
  primaryColor: string;
}

export function BottomNav({
  tabs,
  activeTab,
  onTabChange,
  primaryColor,
}: BottomNavProps) {
  return (
    <nav style={{
      display: "flex",
      background: "#fff",
      borderTop: "1px solid #e0e0e0",
      paddingBottom: "env(safe-area-inset-bottom, 0px)",
    }}>
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 3,
              padding: "10px 0 8px",
              cursor: "pointer",
              background: "none",
              border: "none",
              borderTop: isActive ? `3px solid ${primaryColor}` : "3px solid transparent",
              color: isActive ? primaryColor : "#999",
              transition: "color 0.15s",
            }}
          >
            <span style={{ display: "flex" }}>{tab.icon}</span>
            <span style={{ fontSize: 11, fontWeight: isActive ? 700 : 500 }}>
              {tab.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
